import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './panels.css';

function AboutUcatPanel({ user, apiUrl }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({ title: '', body: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios
      .get(`${apiUrl}/content/about-ucat`)
      .then((r) => {
        setData(r.data);
        setForm({ title: r.data.title, body: r.data.body });
      })
      .finally(() => setLoading(false));
  }, [apiUrl]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await axios.patch(`${apiUrl}/content/about-ucat`, form);
      setData(res.data);
      setEditing(false);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>Loading...
      </div>
    );
  }

  return (
    <div className="panel">
      {editing ? (
        <div className="content-edit-form">
          <input
            type="text"
            className="content-title-input"
            value={form.title}
            onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))}
            placeholder="What is UCAT?"
          />
          <textarea
            className="content-body-textarea"
            value={form.body}
            onChange={(e) => setForm((f) => ({ ...f, body: e.target.value }))}
            rows={20}
            placeholder="Add content... (Markdown supported: # Heading, **bold**, - bullet lists)"
          />
          <div className="content-edit-actions">
            <button className="btn btn-secondary" onClick={() => setEditing(false)} disabled={saving}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
          </div>
        </div>
      ) : (
        <>
          <div className="panel-header-row">
            <h2>{data?.title || 'What is UCAT?'}</h2>
            {user.role === 'admin' && (
              <button className="btn btn-secondary" onClick={() => setEditing(true)}>Edit</button>
            )}
          </div>
          {data?.body ? (
            <div className="content-body markdown-body"><ReactMarkdown remarkPlugins={[remarkGfm]}>{data.body}</ReactMarkdown></div>
          ) : (
            <p className="content-empty">Content hasn't been added yet.</p>
          )}
        </>
      )}
    </div>
  );
}

export default AboutUcatPanel;
